/* Kiro PDP v3 · pixels on shade change
   Changing a shade swaps the product in place (new URL via history.pushState, no page reload), so pixels that only fire on
   page load never see the new shade. On every "kiro:pdp:shade-change" (sent by kiro-v3-pdp.js) this re-sends a page view
   and a product view to every pixel loaded on the page:
   - Meta (fbq): ViewContent only (no PageView: one per page, sent on load)
   - Google (gtag): view_item only (no page_view: one per page, sent on load); Google Tag Manager (dataLayer): "kiro_shade_change" with GA4 ecommerce data
   - Snapchat (snaptr): VIEW_CONTENT only
   - Hotjar: nothing (Hotjar picks up URL changes itself)
   - Shopify Customer events: custom event "kiro_shade_changed" for custom pixels
     (Settings > Customer events: analytics.subscribe('kiro_shade_changed', event => { ... event.customData ... }))
   - Any other script: DOM event "kiro:pixels:shade-view" on document */
(function () {
  'use strict';
  if (window.__kiroPdpPixels) return;
  window.__kiroPdpPixels = true;

  // Google Ads accounts configured in layout/theme.liquid (gtag 'config' calls). Keep in sync if one is added or removed.
  var GOOGLE_ADS_IDS = ['AW-16720724787', 'AW-608802853', 'AW-10785885514'];
  var lastVariant = null;

  function safe(name, fn) {
    try { fn(); } catch (e) { if (window.console) console.warn('[Kiro pixels] ' + name + ' failed', e); }
  }
  function text(selector) {
    var e = document.querySelector(selector);
    return e ? e.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function send(sel) {
    if (!sel || sel.variantId == null) return;
    var variantId = String(sel.variantId);
    if (variantId === lastVariant) return;          // same shade again: nothing new to report
    lastVariant = variantId;

    var value = Math.round(Number(sel.price) || 0) / 100;   // the PDP keeps prices in paise / cents
    var currency = sel.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    var shade = text('kiro-product-page-v3 [data-kp-shade-name]');
    var title = document.title;
    var url = location.href;
    var path = location.pathname + location.search;
    var item = {
      item_id: variantId,
      item_name: title,
      item_variant: shade,
      item_group_id: sel.productId != null ? String(sel.productId) : undefined,
      price: value,
      quantity: 1
    };
    var payload = {
      productId: sel.productId, variantId: sel.variantId, handle: sel.handle, shade: shade, title: title,
      price: value, currency: currency, available: sel.available, url: url
    };

    // Meta: no PageView on shade change, only ViewContent. kiro-v3-pdp.js updates the URL through the native
    // History.prototype.replaceState, which Meta's history hook does not see, so the page counts one PageView (on load).
    if (typeof window.fbq === 'function') safe('Meta', function () {
      fbq('track', 'ViewContent', {
        content_ids: [variantId], content_type: 'product', content_name: title, value: value, currency: currency
      });
    });

    // Google tags loaded with gtag.js: view_item only. No page_view on shade change, so the page counts one page_view
    // (on load). The URL update in kiro-v3-pdp.js bypasses GA4's history hook for the same reason (see Meta above).
    if (typeof window.gtag === 'function') safe('Google', function () {
      // gtag('event', 'page_view', { page_title: title, page_location: url, page_path: path, send_to: GOOGLE_ADS_IDS });
      gtag('event', 'view_item', { currency: currency, value: value, items: [item] });
    });

    // Google Tag Manager (only if a dataLayer exists on the page)
    if (Array.isArray(window.dataLayer)) safe('dataLayer', function () {
      window.dataLayer.push({ ecommerce: null });   // clear the previous ecommerce object (GA4 + GTM convention)
      window.dataLayer.push({
        event: 'kiro_shade_change', page_title: title, page_location: url, page_path: path,
        ecommerce: { currency: currency, value: value, items: [item] }
      });
    });

    // Snapchat
    if (typeof window.snaptr === 'function') safe('Snapchat', function () {
      // snaptr('track', 'PAGE_VIEW');   // one PAGE_VIEW per page, sent on load
      snaptr('track', 'VIEW_CONTENT', { item_ids: [variantId], price: value, currency: currency });
    });

    // Hotjar: nothing here. Hotjar picks up URL changes by itself (its default "track URL changes automatically"),
    // so a manual stateChange would count every shade change twice.

    // Shopify Customer events: custom pixels can subscribe to this
    var analytics = window.Shopify && window.Shopify.analytics;
    if (analytics && typeof analytics.publish === 'function') safe('Shopify', function () {
      analytics.publish('kiro_shade_changed', payload);
    });

    // anything else on the page
    safe('DOM event', function () {
      document.dispatchEvent(new CustomEvent('kiro:pixels:shade-view', { detail: payload }));
    });
  }

  // the shade loaded with the page was already reported by the normal page-load pixels
  document.addEventListener('kiro:pdp:ready', function (e) {
    if (e.detail && e.detail.variantId != null && lastVariant === null) lastVariant = String(e.detail.variantId);
  });
  document.addEventListener('kiro:pdp:shade-change', function (e) {
    var sel = e.detail;
    // let the PDP finish updating the title / shade name for the new shade first
    setTimeout(function () { send(sel); }, 0);
  });
})();
